import React, { useRef } from 'react';
import { Label } from '../../../../../../../common/labels/labelTypes';
import { useDispatch, useSelector } from 'react-redux';
import { getColorDefaultHexValue } from '../../../../../../../common/colors/elementColorFormatUtil';
import CustomColorInput from '../../colorTools/CustomColorInput';
import ColorPopupContent from '../../colorTools/popup/ColorPopupContent';
import { COLOR_POPUP_MODE } from '../../colorTools/popup/colorPopupConstants';
import { COLORS } from '../../../../../../../common/colors/colorConstants';
import currentBoardSuggestedColorSelectorOnlyColors from '../../colorTools/currentBoardSuggestedColorsSelector';
import { updateLabel } from '../../../../../../../common/labels/labelActions';

const LabelColorPicker: React.FC<{ label: Label }> = ({ label }) => {
    const customColorInputRef = useRef<CustomColorInput>(null);
    const suggestedColors = useSelector(currentBoardSuggestedColorSelectorOnlyColors);
    const dispatch = useDispatch();

    const setColor = (color: string | null) => {
        if (!color) return;

        const colorToSave = getColorDefaultHexValue(color);

        dispatch(updateLabel(label.id, { color: colorToSave }));
    };

    const openCustomColorPicker = () => {
        if (!customColorInputRef?.current) return;

        customColorInputRef.current.open();
    };

    return (
        <>
            <CustomColorInput
                className="absolute opacity-0 pointer-events-none"
                ref={customColorInputRef}
                initialColor={label.color}
                setColor={setColor}
            />
            <ColorPopupContent
                supportBackgroundColor={false}
                supportColorBar={false}
                supportDualColors={false}
                setColor={setColor}
                selectedColor={label.color}
                colorPopupMode={COLOR_POPUP_MODE.COLOR}
                defaultColors={Object.values(COLORS)}
                suggestedColors={suggestedColors}
                openCustomColorPicker={openCustomColorPicker}
            />
        </>
    );
};

export default LabelColorPicker;
